<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ this.name ? "编辑用户" : "新建用户" }}</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field label="用户名: " dense v-model="user.name" :rules="rule.name" :readonly="!!this.name" autocomplete="new-password"/>
            </v-col>
            <v-col cols="12">
              <v-text-field label="密码: " type="password" dense v-model="user.password" :rules="rule.password" autocomplete="new-password"/>
            </v-col>
            <v-col cols="12">
              <v-select label="部门: " dense :items="groups" v-model="user.groupName"></v-select>
            </v-col>
            <v-col cols="12">
              <v-treeview :items="items" v-model="user.stores" item-key="name" item-text="name"
                          selectable open-on-click return-object :load-children="getData">
              </v-treeview>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error darken-1" text @click="deleteUser" v-if="this.name">删除用户</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="save">保存</v-btn>
      <v-btn color="blue darken-1" text @click="closePersonDialog(false)">取消</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "PersonEditor",
  props: {
    name: String,
    groupName: String,
    dialogName: String
  },
  data() {
    return {
      user: {
        name: null,
        password: null,
        group: {
          name: this.groupName
        },
        stores: []
      },
      items: [],
      rule: {
        name: [
          v => !!v || "请输入账号",
          v => v && v.length >= 2 && v.length <= 16 || "账号长度只能2-16位."
        ],
        password: [
          v => !!v || "请输入密码",
          v => v && v.length >= 6 && v.length <= 32 || "密码长度只能6-32位."
        ]
      },
      groups: ["IT部", "旺麦旺", "热海科技", "水滴石穿", "华稳"]
    }
  },
  methods: {
    getData() {
      let config = null;
      if (this.name) {
        config = {
          params: {name: this.name}
        }
      }
      this.$axios.get("/user/detail", config).then(
          response => {
            for (let store of response.data.stores) {
              let found;
              for (let category of this.items) {
                if (category.name === store.name.split("-")[1]) {
                  found = category;
                  break;
                }
              }

              if (found) {
                found.children.push(store);
              } else {
                this.items.push({id: store.name.split("-")[1], name: store.name.split("-")[1], children: [store]});
              }
            }

            if (response.data.user) {
              this.user = response.data.user;
              this.user.password = "******";
            }
          }
      );
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.user.password === "******") {
          this.user.password = null;
        }
        this.$axios.post(this.$format("/user/{}", this.name), this.user).then(
            () => {
              this.closePersonDialog(true);
            },
            error => {
              alert(JSON.stringify(error));
            }
        );
      }
      console.log(this.user.stores);
    },
    deleteUser() {
      this.$axios.delete(this.$format("/user/{}", this.name)).then(
          response => {
            console.log(response);
            this.closePersonDialog(true);
          }
      );
    },
    closePersonDialog(isRefresh) {
      this.$emit("closePersonDialog", this.dialogName, isRefresh);
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped>

</style>